import {
  type SignInResult,
  SignInStatus,
  type SsoSignInRequest,
  postAuthSso,
} from "Infrastructure/Api/Api";
import type { NavigateFunction } from "Navigation/useNavigate";
import { afterSignInSuccess } from "Utils/AuthUtils";
import { LocalStorageKeys } from "Utils/Storage/LocalStorage/LocalStorageKeys";
import { removeLocalStorageItem } from "Utils/Storage/LocalStorage/SecureLocalStorage";
import { call, put, takeLatest } from "typed-redux-saga";
import { createAsyncAction, getType } from "typesafe-actions";

export const signInSsoAsync = createAsyncAction(
  "@auth/SIGN_IN_SSO_REQUEST",
  "@auth/SIGN_IN_SSO_SUCCESS",
  "@auth/SIGN_IN_SSO_FAILURE",
)<
  { model: SsoSignInRequest; navigate: NavigateFunction },
  SignInResult,
  Error
>();

function* signInSso(
  action: ReturnType<typeof signInSsoAsync.request>,
): Generator {
  try {
    const response = yield* call(postAuthSso, action.payload.model);
    if (response.status === 200) {
      yield put(signInSsoAsync.success(response.data));
      if (response.data.status === SignInStatus.Success) {
        // A sign-up intent reached the server (or the person just signed in) — a leftover
        // would leak into a future registration from the same browser.
        removeLocalStorageItem(LocalStorageKeys.RoleIntent);
        yield* call(afterSignInSuccess, response.data, action.payload.navigate);
      }
    } else {
      yield put(
        signInSsoAsync.failure(
          new Error(`Error in action ${action.type}`, {
            cause: response.status,
          }),
        ),
      );
    }
  } catch (err) {
    yield put(signInSsoAsync.failure(err as Error));
  }
}
export function* signInSsoSaga() {
  yield takeLatest(getType(signInSsoAsync.request), signInSso);
}
